exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.legendDivider {\n  margin-bottom: 5px;\n}\n.legendItem {\n  margin: 2px 0px 2px 15px;\n}\n.legendItemIcon {\n  margin-right: 5px;\n}\n.legendItemText {\n  vertical-align: middle;\n}\n.legendSectionHeader {\n  margin: 7px 0px 5px 10px;\n}\n", ""]);

// exports
